<template>
	<div>
	<div class="inhonorof">
		<FormRow>
			  <input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/>
			  <FormLabel for="inHonorOf">Dedicate your donation</FormLabel>
		</FormRow>
		<div  v-if="inHonorOf" class="honor-container">
			<FormRow inline>
				<FormCol field="dedication">
					<FormSelect>
					<option value="In honor of">In honor of</option>
					<option value="In memory of">In memory of</option>
					<option value="For the recovery of">For the recovery of</option>
					</FormSelect>
				</FormCol>
				<FormCol field="honoreeName" />
			</FormRow>
			<FormRow inline>
				<FormCol field="dedicationMessage" />
			</FormRow>
      <FormRow inline v-if="recipientFlag">
        <FormCol field="recipientName" />
        <FormCol field="recipientEmail" />
      </FormRow>
      <FormRow inline v-if="recipent">
        <span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}">
          <span v-if="!recipientFlag">+ Add </span>
          <span v-else>- Remove </span>
          recipient
          <span v-if="!recipientFlag"> to notify</span>
        </span>
      </FormRow>
      <FormRow>
			  <input type="checkbox" id="nameMentioned" name="nameMentioned" v-model="nameMentioned"/>
			  <FormLabel for="nameMentioned">I would like my name mentioned in the dedication</FormLabel>
			</FormRow>
			<FormRow v-if="nameMentioned" inline>
				<FormCol field="custom.dedication_name" width="full">
					<FormInput type="text" />
				</FormCol>
			</FormRow>
		</div>
	</div>
	</div>
	</template>
	<script lang="ts">
	import { defineComponent,  ref, watch } from 'vue'

	export default defineComponent({
	  props: {
		recipent: {
		  type: Boolean,
		  default: true
		},
	  },
	  setup() {
		  const inHonorOf = ref(false)
		  const recipientFlag = ref(false)
		  const nameMentioned = ref(false)
		  const dedicationDate = ref(false)

		  return {
			  inHonorOf,
			  recipientFlag,
			  nameMentioned,
			  dedicationDate
		  }
	  }
	})
	</script>
	<style scoped lang="scss">
	input[type="checkbox"] {
		margin-right: 7px;
	}
	.honor-container {
		padding-top: 20px;
		border-top: 1px solid #ddd;
		margin-top: 20px;
	}
	.flex {
		display: flex;
		align-items: center;
	}
	.honor-type {
		max-width: 150px;
		min-width: 150px;
		margin-right: 7px;
	}
	.edit-recipient {
		color: $color-blue;
		font-size: 13px;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}

	}
	</style>
